import { NgModule } from '@angular/core';
import { BrowserModule, Meta } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http'
import { NgOptimizedImage } from '@angular/common'
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { StepsModule } from 'primeng/steps';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { MessagesModule } from 'primeng/messages';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ImageModule } from 'primeng/image';
import { CardModule } from 'primeng/card';
import { FieldsetModule } from 'primeng/fieldset';
import { GalleriaModule } from 'primeng/galleria';
import { SkeletonModule } from 'primeng/skeleton';
import { ChipModule } from 'primeng/chip';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DialogModule } from 'primeng/dialog';
import { MenuModule } from 'primeng/menu';
import { KnobModule } from 'primeng/knob';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TagModule } from 'primeng/tag';
import { SidebarModule } from 'primeng/sidebar';
import { DeferModule } from 'primeng/defer';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TimelineModule } from 'primeng/timeline';
import { ChartModule } from 'primeng/chart';
import { InplaceModule } from 'primeng/inplace';
import { CalendarModule } from 'primeng/calendar';
import { DividerModule } from 'primeng/divider';
import { EditorModule } from 'primeng/editor';

import { HeaderComponent } from './components/public//header/header.component';
import { FooterComponent } from './components/public/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { ProfileComponent } from './components/profile/profile.component';
import { PersonListComponent } from './components/person-list/person-list.component';
import { UserRegisterComponent } from './components/user-register/user-register.component';
import { PersonRegisterComponent } from './components/person-register/person-register.component';
import { MediaUploadComponent } from './components/media-upload/media-upload.component';
import { LoginComponent } from './components/login/login.component';
import { EndRegisterComponent } from './components/end-register/end-register.component';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { ProfileDetailsComponent } from './components/profile-details/profile-details.component';
import { AdministrationComponent } from './components/administration/administration.component';
import { TermsComponent } from './components/terms/terms.component';
import { AboutComponent } from './components/about/about.component';
import { BlogComponent } from './components/blog/blog.component';
import { EditMediaComponent } from './components/edit-media/edit-media.component';
import { SubscriptionListComponent } from './components/subscription-list/subscription-list.component';
import { ErrorComponent } from './components/error/error.component';
import { EditPasswordComponent } from './components/edit-password/edit-password.component';
import { EditUsernameComponent } from './components/edit-username/edit-username.component';
import { ContactusComponent } from './components/contactus/contactus.component';
import { TimelineComponent } from './components/timeline/timeline.component';
import { InteractionStatisticsComponent } from './components/interaction-statistics/interaction-statistics.component';
import { CreateActivityComponent } from './components/create-activity/create-activity.component';
import { AlliesComponent } from './components/allies/allies.component';
import { SubscriptionDetailComponent } from './components/subscription-detail/subscription-detail.component';
import { CreateArticleComponent } from './components/create-article/create-article.component';
import { CreatePaymentComponent } from './components/create-payment/create-payment.component';
import { ArticleListComponent } from './components/article-list/article-list.component';
import { ReadArticleComponent } from './components/read-article/read-article.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    ProfileComponent,
    PersonListComponent,
    UserRegisterComponent,
    PersonRegisterComponent,
    MediaUploadComponent,
    LoginComponent,
    EndRegisterComponent,
    EditProfileComponent,
    ProfileDetailsComponent,
    AdministrationComponent,
    TermsComponent,
    AboutComponent,
    BlogComponent,
    EditMediaComponent,
    SubscriptionListComponent,
    ErrorComponent,
    EditPasswordComponent,
    EditUsernameComponent,
    ContactusComponent,
    TimelineComponent,
    InteractionStatisticsComponent,
    CreateActivityComponent,
    AlliesComponent,
    SubscriptionDetailComponent,
    CreateArticleComponent,
    CreatePaymentComponent,
    ArticleListComponent,
    ReadArticleComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    ButtonModule,
    InputTextModule,
    PasswordModule,
    StepsModule,
    InputTextareaModule,
    DropdownModule,
    FileUploadModule,
    MessagesModule,
    ToastModule,
    ImageModule,
    CardModule,
    FieldsetModule,
    GalleriaModule,
    SelectButtonModule,
    SkeletonModule,
    ChipModule,
    InputNumberModule,
    RadioButtonModule,
    CheckboxModule,
    DialogModule,
    MenuModule,
    KnobModule,
    TableModule,
    MultiSelectModule,
    PanelModule,
    ConfirmDialogModule,
    TagModule,
    SidebarModule,
    DeferModule,
    OverlayPanelModule,
    ProgressSpinnerModule,
    TimelineModule,
    ChartModule,
    InplaceModule,
    CalendarModule,
    DividerModule
  ],
  providers: [MessageService, CookieService, ConfirmationService, Meta],
  bootstrap: [AppComponent]
})
export class AppModule { }
